import axios from "axios";
import {
    API_FILTERS,
    START_DATE_KEY,
    ID_REL_KEY,
    KEYS_MAP,
    RESULTS_PER_PAGE,
    URL_VISOR,
    API_SEARCH_SEMANTICA,
    API_SEARCH_SEMANTICA_SENTENCIA,
    API_ABSTRACT,
    API_COUNT,
    LOG_BORRADOR,
    CITADO_EN,
} from "./settings";
import store from "../store";
import { omitBy, isUndefined, split, filter } from "lodash";

const buildQuery = (searchText, filters) => {
    const document_search_text_selector = store.getState().searchDocumentText;

    const finalSearchText = escapeSpecialCharacters(searchText);

    let query_must_body = null;

    let documentoAjustado = document_search_text_selector
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z 0-9.]+/g, " ")
        .substring(0, 5000);

    if (document_search_text_selector !== "") {
        query_must_body = {
            query_string: {
                query: documentoAjustado,
                fields: ["documento_principal.contenido_archivo"],
            },
        };
    } else {
        query_must_body = {
            query_string: {
                query: `${finalSearchText}`,
                fields: [
                    "problemas_juridicos_temas.posicion_doctrinal_actual",
                    "problemas_juridicos_temas.posicion_doctrinal_contraria",
                    "problemas_juridicos_temas.pregunta",
                    "problemas_juridicos_temas.reiteracion_doctrina",
                    "documento_principal.contenido_archivo",
                    "metadatos.Antecedentes",
                    "metadatos.Consideraciones",
                    "metadatos.Costas",
                    "metadatos.Hechos",
                    "metadatos.Pretensiones",
                    "metadatos.Resuelve",
                    "descriptores.descriptor_principal",
                    "descriptores.descriptores_secundarios",
                    "titulo",
                    "analisis_estadistico.excepciones_esgrimidas_reconvencion",
                    "analisis_estadistico.expediente_tribunal",
                    "analisis_estadistico.fecha_segunda_instancia",
                    "analisis_estadistico.hechos_relevantes_contestacion_de_demanda",
                    "analisis_estadistico.hechos_relevantes_demanda",
                    "analisis_estadistico.intervencion_terceros",
                    "analisis_estadistico.juramento_estimatorio",
                    "analisis_estadistico.parte_resolutiva_primera_instancia",
                    "analisis_estadistico.parte_resolutiva_segunda_instancia",
                    "analisis_estadistico.pretensiones_esgrimidas_reconvencion",
                    "analisis_estadistico.pretensiones_presentadas_en_la_demanda",
                    "analisis_estadistico.sentido_del_fallo_primera_instancia",
                    "analisis_estadistico.sentido_del_fallo_segunda_instancia",
                    "analisis_juridico.aclaracion_o_adicion",
                    "analisis_juridico.consideraciones_adicionales",
                    "analisis_juridico.problemas_juridicos.problema",
                    "analisis_juridico.problemas_juridicos.tesis",
                    "analisis_juridico.rattio_decidendi",
                    "analisis_juridico.segunda_instancia",
                    "analisis_pautas_legales.preguntas_problemas_juridicos.preguntasProblema",
                    "analisis_pautas_legales.preguntas_problemas_juridicos.respuestasFuentes",
                    "analisis_pautas_legales.sintesis_segunda_instancia",
                    "analisis_pautas_legales.pautas_legales",
                    "analisis_pautas_legales.referencias_pautas_legales.referenciasAfines",
                    "analisis_pautas_legales.referencias_pautas_legales.referenciasDiscordantes",
                    "fuentes_juridicas.fuente",
                    "informacion.consecutivo",
                    "informacion.normatividad",
                    "informacion.numero_proceso",
                    "informacion.numero_radicado",
                    "informacion.tema",
                    "informacion.tramite",
                    "partes.nombre",
                    "titulo_sentencia",
                    "informacion.fecha_larga"
                ],
                default_operator: "AND",
            },
        };
    }

    let query = {
        query: {
            bool: {
                must: [query_must_body],
                filter: filters,
            },
        },
        aggregations: {
            contentType: {
                terms: {
                    field: "informacion.tipo_contenido.keyword",
                    size: 1000,
                },
            },
        },
    };

    // la idea es no enviar el must de la peticion si query string es vacio
    if (document_search_text_selector === "" && finalSearchText === "") {
        delete query.query.bool.must;
    }

    return query;
};

const buildQueryDocument = (searchDocumentText, filters) => {
    // let documentoAjustado = searchDocumentText
    //     .normalize("NFD")
    //     .replace(/[\u0300-\u036f]/g, "")
    //     .replace(/[^a-zA-Z 0-9.]+/g, " ")
    //     .substring(0, 5000);

    // if (searchDocumentText.indexOf("-") > 0) {
    //     searchDocumentText = searchDocumentText.replace("-", " - ");
    // }

    const query_must_body = {
        query_string: {
            query: `${searchDocumentText}`,
            fields: [
                "problemas_juridicos_temas.posicion_doctrinal_actual",
                "problemas_juridicos_temas.posicion_doctrinal_contraria",
                "problemas_juridicos_temas.pregunta",
                "problemas_juridicos_temas.reiteracion_doctrina",
                "documento_principal.contenido_archivo",
                "metadatos.Antecedentes",
                "metadatos.Consideraciones",
                "metadatos.Costas",
                "metadatos.Hechos",
                "metadatos.Pretensiones",
                "metadatos.Resuelve",
                "descriptores.descriptor_principal",
                "descriptores.descriptores_secundarios",
                "titulo",
                "analisis_estadistico.excepciones_esgrimidas_reconvencion",
                "analisis_estadistico.expediente_tribunal",
                "analisis_estadistico.fecha_segunda_instancia",
                "analisis_estadistico.hechos_relevantes_contestacion_de_demanda",
                "analisis_estadistico.hechos_relevantes_demanda",
                "analisis_estadistico.intervencion_terceros",
                "analisis_estadistico.juramento_estimatorio",
                "analisis_estadistico.parte_resolutiva_primera_instancia",
                "analisis_estadistico.parte_resolutiva_segunda_instancia",
                "analisis_estadistico.pretensiones_esgrimidas_reconvencion",
                "analisis_estadistico.pretensiones_presentadas_en_la_demanda",
                "analisis_estadistico.sentido_del_fallo_primera_instancia",
                "analisis_estadistico.sentido_del_fallo_segunda_instancia",
                "analisis_juridico.aclaracion_o_adicion",
                "analisis_juridico.consideraciones_adicionales",
                "analisis_juridico.problemas_juridicos.problema",
                "analisis_juridico.problemas_juridicos.tesis",
                "analisis_juridico.rattio_decidendi",
                "analisis_juridico.segunda_instancia",
                "analisis_pautas_legales.preguntas_problemas_juridicos.preguntasProblema",
                "analisis_pautas_legales.preguntas_problemas_juridicos.respuestasFuentes",
                "analisis_pautas_legales.sintesis_segunda_instancia",
                "analisis_pautas_legales.pautas_legales",
                "analisis_pautas_legales.referencias_pautas_legales.referenciasAfines",
                "analisis_pautas_legales.referencias_pautas_legales.referenciasDiscordantes",
                "fuentes_juridicas.fuente",
                "informacion.tema",
                "partes.nombre",
                "titulo_sentencia",
                "informacion.fecha_larga"
            ],
            default_operator: "OR",
        },
    };

    let query = {
        query: {
            bool: {
                must: [query_must_body],
                filter: filters,
            },
        },
        aggregations: {
            contentType: {
                terms: {
                    field: "informacion.tipo_contenido.keyword",
                    size: 1000,
                },
            },
        },
    };

    // la idea es no enviar el must de la peticion si query string es vacio
    if (searchDocumentText === "") {
        delete query.query.bool.must;
    }

    return query;
};

/**
 * Constructor de filtros para request semántico
 * @param {*} filters Filtros en formato json
 */
export const buildSemanticFilters = (filters) => {
    const {
        hechosRelevantesDemanda,
        hechosRelevantesContestacionDemanda,
        pretensionesDemanda,
    } = filters;

    // Se formatean las propiedades con sus nuevos nombres
    const semanticFilters = {
        hechos_contestacion: hechosRelevantesContestacionDemanda,
        hechos_demanda: hechosRelevantesDemanda,
        pretensiones_demanda: pretensionesDemanda,
    };

    // Se limpian las propiedades que queden como undefined
    return omitBy(semanticFilters, (el) => isUndefined(el) || el === "");
};

export const buildFilters = (filters, tipoContenido = "") => {
    let filterArray = [];

    // arma array de filtros exceptuando fecha providencia
    Object.keys(KEYS_MAP).map((key) => {
        if (filters[key] !== undefined && filters[key] !== "") {
            let filter = {
                match: {
                    [KEYS_MAP[key]]: {
                        query: filters[key],
                        operator: "and",
                    },
                },
            };

            filterArray.push(filter);
        }

        return null;
    });

    if (Object.keys(filters).length > 0) {
        if (filters.startDate !== "" && filters.endDate !== "") {
            let rangeDate = {
                range: {
                    [START_DATE_KEY]: {
                        gte: filters.startDate, //Mayor que o igual
                        lte: filters.endDate, //Menos que o igual
                    },
                },
            };

            filterArray.push(rangeDate);
        }

        if (filters.startDate !== "" && filters.endDate === "") {
            let rangeDate = {
                range: {
                    [START_DATE_KEY]: {
                        gte: filters.startDate,
                    },
                },
            };

            filterArray.push(rangeDate);
        }

        if (filters.expediente !== "" && filters.expediente !== undefined) {
            const queryBusqueda = filters.expediente
                .trim()
                .replace(" - ", "-")
                .split("-");

            if (queryBusqueda.length === 2) {
                let filterAnio = {
                    match: {
                        "informacion.ano_expediente": {
                            query: queryBusqueda[0],
                            operator: "and",
                        },
                    },
                };

                let filterNumero = {
                    match: {
                        "informacion.numero_expediente": {
                            query: queryBusqueda[1],
                            operator: "and",
                        },
                    },
                };

                filterArray.push(filterAnio, filterNumero);
            } else {
                let filterNumero = {
                    match: {
                        "informacion.numero_expediente": {
                            query: queryBusqueda[0],
                            operator: "and",
                        },
                    },
                };

                filterArray.push(filterNumero);
            }
        }
    }

    return filterArray;
};

export function escapeSpecialCharacters(searchValue) {
    let cleanText = "";
    const escapeText = "\\";
    const slashEscape = "\\/";

    const specialCharacters = [
        "+",
        "-",
        "=",
        "&&",
        "|",
        "|",
        ">",
        "<",
        "!",
        "(",
        ")",
        "{",
        "}",
        "[",
        "]",
        "^",
        '"',
        "~",
        "*",
        "?",
        ":",
        "]",
    ];

    specialCharacters.forEach((specialChracter) => {
        if (searchValue.includes(specialChracter)) {
            cleanText = searchValue.replaceAll(
                specialChracter,
                `${escapeText}${specialChracter}`
            );
        }
    });

    if (cleanText !== "") {
        return cleanText;
    }

    if (searchValue.includes("/")) {
        cleanText = searchValue.replaceAll("/", `${slashEscape}`);
        return cleanText;
    }

    return searchValue;
}

export const buildSort = (sort) => {
    const { field, order } = sort;

    const bSort = [];
    if (field === "informacion.tipo_contenido.keyword") {
        bSort.push({
            "titulo.keyword": {
                order: order,
            },
        });
    }

    bSort.push(
        {
            [field]: {
                order,
            },
        },
        "_score"
    );

    return bSort;
};

/**
 * Busqueda por texto y/o filtros con ElasticSearch
 * @param {*} searchValue
 * @param {*} filters
 * @param {*} pageNum
 * @returns
 */
export function search(searchValue, filters, pageNum, sort) {
    let finalSearchValue = searchValue;
    // let finalSearchValue = "";
    // if (searchValue !== "*") {
    //     let splitSearchText = searchValue.split(" ");
    //     splitSearchText.forEach((element) => {
    //         if (element.length > 2) {
    //             finalSearchValue += element + " ";
    //         }
    //         // if (element === "?" || element === "¿") {
    //         //     finalSearchValue += element + " ";
    //         // }
    //     });
    //     finalSearchValue = finalSearchValue.trim();
    // } else {
    //     finalSearchValue = searchValue;
    // }

    const queryBuilded = buildQuery(finalSearchValue, filters);

    let query = {
        // ...buildQuery(finalSearchValue, filters),
        ...queryBuilded,
        size: RESULTS_PER_PAGE,
        // size: 1,
        from: RESULTS_PER_PAGE * (pageNum - 1),
        highlight: {
            fields: {
                "analisis_estadistico.excepciones_esgrimidas_contra_la_demanda": {},
                "analisis_estadistico.excepciones_esgrimidas_reconvencion": {},
                "analisis_estadistico.expediente_tribunal": {},
                "analisis_estadistico.fecha_segunda_instancia": {},
                "analisis_estadistico.hechos_relevantes_contestacion_de_demanda": {},
                "analisis_estadistico.hechos_relevantes_demanda": {},
                "analisis_estadistico.intervencion_terceros": {},
                "analisis_estadistico.juramento_estimatorio": {},
                "analisis_estadistico.parte_resolutiva_primera_instancia": {},
                "analisis_estadistico.parte_resolutiva_segunda_instancia": {},
                "analisis_estadistico.pretensiones_esgrimidas_reconvencion": {},
                "analisis_estadistico.pretensiones_presentadas_en_la_demanda": {},
                "analisis_estadistico.sentido_del_fallo_primera_instancia": {},
                "analisis_estadistico.sentido_del_fallo_segunda_instancia": {},
                "analisis_juridico.aclaracion_o_adicion": {},
                "analisis_juridico.consideraciones_adicionales": {},
                "analisis_juridico.problemas_juridicos.problema": {},
                "analisis_juridico.problemas_juridicos.tesis": {},
                "analisis_juridico.rattio_decidendi": {},
                "analisis_juridico.segunda_instancia": {},
                "analisis_pautas_legales.preguntas_problemas_juridicos.preguntasProblema": {},
                "analisis_pautas_legales.preguntas_problemas_juridicos.respuestasFuentes": {},
                "analisis_pautas_legales.sintesis_segunda_instancia": {},
                "analisis_pautas_legales.pautas_legales": {},
                "analisis_pautas_legales.referencias_pautas_legales.referenciasAfines": {},
                "analisis_pautas_legales.referencias_pautas_legales.referenciasDiscordantes": {},
                "archivos.nombre": {},
                "archivos.ruta_s3": {},
                "borrador.keyword": {},
                "citas.fuente": {},
                "citas.fuente_reforma": {},
                "citas.hipervinculo": {},
                "descriptores.descriptor_principal": {},
                "descriptores.descriptores_secundarios": {},
                "documento_principal.contenido_archivo": {
                    "number_of_fragments" : 3,  
                    "fragment_size" : 200, 
                    "fragmenter": "simple", 
                    "boundary_scanner": "sentence"
                },
                "documento_principal.metadatos": {},
                "documento_principal.ruta_s3": {},
                "fuentes_juridicas.actions": {},
                "fuentes_juridicas.estado": {},
                "fuentes_juridicas.fuente": {},
                "fuentes_juridicas.fuente_reforma": {},
                "fuentes_juridicas.hipervinculo": {},
                "fuentes_juridicas.tipo": {},
                "id_relatoria.keyword": {},
                "informacion.ano_expediente": {},
                "informacion.consecutivo": {},
                "informacion.fecha_sentencia": {},
                "informacion.fecha_ultima_modificacion": {},
                "informacion.normatividad": {},
                "informacion.numero_proceso": {},
                "informacion.numero_radicado": {},
                "informacion.tema": {},
                "informacion.tramite": {},
                "metadatos.Antecedentes": {},
                "metadatos.Consideraciones": {
                    "number_of_fragments" : 3,  
                    "fragment_size" : 150, 
                    "fragmenter": "simple", 
                    "boundary_scanner": "sentence"
                },
                "metadatos.Costas": {},
                "metadatos.Hechos": {},
                "metadatos.Pretensiones": {},
                "metadatos.Resuelve": {},
                "partes.nombre": {},
                "partes.numero_doc": {},
                "partes.rol": {},
                "partes.tipo_doc": {},
                "problemas_juridicos_temas.posicion_doctrinal_actual": {
                    "number_of_fragments": 200,
                    "fragment_size": 200
                },
                "problemas_juridicos_temas.posicion_doctrinal_contraria": {},
                "problemas_juridicos_temas.pregunta": {
                    "number_of_fragments": 100,
                    "fragment_size": 50000
                },
                "problemas_juridicos_temas.reiteracion_doctrina": {},
                "titulo.keyword": {},
            },
        },
    };

    // En caso de que haya un objeto de ordenamiento
    if (sort && Object.entries(sort).length > 0) {
        const bSort = buildSort(sort);
        //Se añade a la query
        query = {
            ...query,
            sort: bSort,
        };
    }

    if (query.query.bool.must !== undefined) {
        if (query.query.bool.must[0].query_string.query.includes('\\"')) {
            query.query.bool.must[0].query_string.query =
                queryBuilded.query.bool.must[0].query_string.query.replaceAll(
                    "\\",
                    ""
                );
        }
    }

//    return axios.post(API_FILTERS, query).then((res) => {
//        return res;
//    });


    return axios
         .get(API_FILTERS, {
             params: {
                 source: JSON.stringify(query),
                 source_content_type: "application/json",
             },
         })
         .then((res) => {
             return res;
         });
}

/**
 * Busqueda por documento con ElasticSearch
 * @param {*} searchValue
 * @param {*} filters
 * @param {*} pageNum
 * @returns
 */
export function searchDocument(searchValue, filters, pageNum, sort) {
    let finalSearchValue = "";

    if (searchValue !== "*") {
        let splitSearchText = searchValue.split(" ");
        splitSearchText.forEach((element) => {
            if (element.length > 3) {
                finalSearchValue += element + " ";
            }
            if (element === "?" || element === "¿") {
                finalSearchValue += element + " ";
            }
        });
        finalSearchValue = finalSearchValue.trim();
    } else {
        finalSearchValue = searchValue;
    }

    let query = {
        ...buildQueryDocument(finalSearchValue, filters),
        size: RESULTS_PER_PAGE,
        from: RESULTS_PER_PAGE * (pageNum - 1),
        highlight: {
            fields: {
                "analisis_estadistico.excepciones_esgrimidas_contra_la_demanda":
                    {},
                "analisis_estadistico.excepciones_esgrimidas_reconvencion": {},
                "analisis_estadistico.expediente_tribunal": {},
                "analisis_estadistico.fecha_segunda_instancia": {},
                "analisis_estadistico.hechos_relevantes_contestacion_de_demanda":
                    {},
                "analisis_estadistico.hechos_relevantes_demanda": {},
                "analisis_estadistico.intervencion_terceros": {},
                "analisis_estadistico.juramento_estimatorio": {},
                "analisis_estadistico.parte_resolutiva_primera_instancia": {},
                "analisis_estadistico.parte_resolutiva_segunda_instancia": {},
                "analisis_estadistico.pretensiones_esgrimidas_reconvencion": {},
                "analisis_estadistico.pretensiones_presentadas_en_la_demanda":
                    {},
                "analisis_estadistico.sentido_del_fallo_primera_instancia": {},
                "analisis_estadistico.sentido_del_fallo_segunda_instancia": {},
                "analisis_juridico.aclaracion_o_adicion": {},
                "analisis_juridico.consideraciones_adicionales": {},
                "analisis_juridico.problemas_juridicos.problema": {},
                "analisis_juridico.problemas_juridicos.tesis": {},
                "analisis_juridico.rattio_decidendi": {},
                "analisis_juridico.segunda_instancia": {},
                "analisis_pautas_legales.preguntas_problemas_juridicos.preguntasProblema": {},
                "analisis_pautas_legales.preguntas_problemas_juridicos.respuestasFuentes": {},
                "analisis_pautas_legales.sintesis_segunda_instancia": {},
                "analisis_pautas_legales.pautas_legales": {},
                "analisis_pautas_legales.referencias_pautas_legales.referenciasAfines": {},
                "analisis_pautas_legales.referencias_pautas_legales.referenciasDiscordantes": {},
                "descriptores.descriptor_principal": {},
                "descriptores.descriptores_secundarios": {},
                "documento_principal.contenido_archivo": {},
                "fuentes_juridicas.fuente": {},
                "informacion.tema": {},
                "metadatos.Antecedentes": {},
                "metadatos.Consideraciones": {},
                "metadatos.Costas": {},
                "metadatos.Hechos": {},
                "metadatos.Pretensiones": {},
                "metadatos.Resuelve": {},
                "partes.nombre": {},
                "problemas_juridicos_temas.posicion_doctrinal_actual": {},
                "problemas_juridicos_temas.posicion_doctrinal_contraria": {},
                "problemas_juridicos_temas.pregunta": {},
                "problemas_juridicos_temas.reiteracion_doctrina": {},
                titulo: {},
            },
        },
    };

    // En caso de que haya un objeto de ordenamiento
    if (sort && Object.entries(sort).length > 0) {
        const bSort = buildSort(sort);
        //Se añade a la query
        query = {
            ...query,
            sort: bSort,
        };
    }

    // console.log("QUERY=======>", query);

    // return axios.post(API_FILTERS, query).then((res) => {
    //     return res;
    // });

    alert("p1: " + query.size);

    return axios
    .get(API_FILTERS, {
        params: {
            source: JSON.stringify(query),
            source_content_type: "application/json",
        },
    })
    .then((res) => {
        return res;
    });
}

export async function searchDocumentSemantic(
    searchValue,
    filters,
    pageNum,
    filterDoc,
    sort
) {
    // let textToSearch = searchValue.replace(/['"]+/g, "");
    // textToSearch = textToSearch.replaceAll(/(\r\n|\n|\r)/gm, " ");

    // const textToSearch = searchValue;

    const textToSearch = searchValue
        .replace('"', "")
        .replace(/(\r\n|\n|\r)/gm, " ")
        .replace(/\t/gm, "")
        .replace(/,{2,}/gm, "")
        .replace(/\\/g, "")
        .replace(/[^a-zA-Z0-9 ]/g, "");

    let filterSemantic = "";
    if (filterDoc !== "") {
        filterSemantic = filterDoc;
    } else {
        filterSemantic = "all";
    }
    if (filters.length > 0) {
        const contentType =
            filters[0]["match"]["informacion.tipo_contenido"]["query"];
        if (contentType === "Temas y problemas") {
            filterSemantic = "tema";
        }
        if (contentType === "Conceptos jurídicos") {
            filterSemantic = "concepto";
        }
        if (contentType.includes("Sentencia")) {
            filterSemantic = "sentencia";
        }
    }

    try {
        const body = {
            texto: textToSearch,
            // filter: filters,
            filter: [],
            filter_doc: filterSemantic,
            size: RESULTS_PER_PAGE,
            from: (pageNum - 1) * RESULTS_PER_PAGE,
        };
        if (Object.keys(sort).length > 0) {
            body["sort"] = sort;
        }
        if (sort && Object.entries(sort).length > 0) {
            const { field, order } = sort;
            //Se añade el sort al body
            body["sort"] = [
                {
                    [field]: {
                        order,
                    },
                },
                "_score",
            ];
        }

        const response = await fetch(API_SEARCH_SEMANTICA, {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "*",
                "Access-Control-Allow-Methods": "*",
            },
        });
        const { result_elasticsearch } = await response.json();

        // Adaptación temporal para hacerla compatible con las vistas
        return { data: result_elasticsearch };
    } catch (err) {
        console.error("Error searchDocumentSemantic: ", err);
        throw new Error("Empty result");
    }
}

export function sort(searchValue, filters, pageNum, sortType) {
    let query = {
        ...buildQuery(searchValue, filters),
        size: RESULTS_PER_PAGE,
        from: RESULTS_PER_PAGE * (pageNum - 1),

        highlight: {
            fields: {
                "analisis_estadistico.excepciones_esgrimidas_contra_la_demanda":
                    {},
                "analisis_estadistico.excepciones_esgrimidas_reconvencion": {},
                "analisis_estadistico.expediente_tribunal": {},
                "analisis_estadistico.fecha_segunda_instancia": {},
                "analisis_estadistico.hechos_relevantes_contestacion_de_demanda":
                    {},
                "analisis_estadistico.hechos_relevantes_demanda": {},
                "analisis_estadistico.intervencion_terceros": {},
                "analisis_estadistico.juramento_estimatorio": {},
                "analisis_estadistico.parte_resolutiva_primera_instancia": {},
                "analisis_estadistico.parte_resolutiva_segunda_instancia": {},
                "analisis_estadistico.pretensiones_esgrimidas_reconvencion": {},
                "analisis_estadistico.pretensiones_presentadas_en_la_demanda":
                    {},
                "analisis_estadistico.sentido_del_fallo_primera_instancia": {},
                "analisis_estadistico.sentido_del_fallo_segunda_instancia": {},
                "analisis_juridico.aclaracion_o_adicion": {},
                "analisis_juridico.consideraciones_adicionales": {},
                "analisis_juridico.problemas_juridicos.problema": {},
                "analisis_juridico.problemas_juridicos.tesis": {},
                "analisis_juridico.rattio_decidendi": {},
                "analisis_juridico.segunda_instancia": {},
                "analisis_pautas_legales.preguntas_problemas_juridicos.preguntasProblema": {},
                "analisis_pautas_legales.preguntas_problemas_juridicos.respuestasFuentes": {},
                "analisis_pautas_legales.sintesis_segunda_instancia": {},
                "analisis_pautas_legales.pautas_legales": {},
                "analisis_pautas_legales.referencias_pautas_legales.referenciasAfines": {},
                "analisis_pautas_legales.referencias_pautas_legales.referenciasDiscordantes": {},
                "archivos.nombre": {},
                "archivos.ruta_s3": {},
                "borrador.keyword": {},
                "citas.fuente": {},
                "citas.fuente_reforma": {},
                "citas.hipervinculo": {},
                "descriptores.descriptor_principal": {},
                "descriptores.descriptores_secundarios": {},
                "documento_principal.contenido_archivo": {},
                "documento_principal.metadatos": {},
                "documento_principal.ruta_s3": {},
                "fuentes_juridicas.actions": {},
                "fuentes_juridicas.estado": {},
                "fuentes_juridicas.fuente": {},
                "fuentes_juridicas.fuente_reforma": {},
                "fuentes_juridicas.hipervinculo": {},
                "fuentes_juridicas.tipo": {},
                "id_relatoria.keyword": {},
                "informacion.ano_expediente": {},
                "informacion.consecutivo": {},
                "informacion.fecha_sentencia": {},
                "informacion.fecha_ultima_modificacion": {},
                "informacion.normatividad": {},
                "informacion.numero_proceso": {},
                "informacion.numero_radicado": {},
                "informacion.tema": {},
                "informacion.tramite": {},
                "metadatos.Antecedentes": {},
                "metadatos.Consideraciones": {},
                "metadatos.Costas": {},
                "metadatos.Hechos": {},
                "metadatos.Pretensiones": {},
                "metadatos.Resuelve": {},
                "partes.nombre": {},
                "partes.numero_doc": {},
                "partes.rol": {},
                "partes.tipo_doc": {},
                "problemas_juridicos_temas.posicion_doctrinal_actual": {},
                "problemas_juridicos_temas.posicion_doctrinal_contraria": {},
                "problemas_juridicos_temas.pregunta": {},
                "problemas_juridicos_temas.reiteracion_doctrina": {},
                "titulo.keyword": {},
            },
        },
    };

    alert("p2: " + query.size);

    return axios
        .get(API_FILTERS, {
            params: {
                source: JSON.stringify(query),
                source_content_type: "application/json",
            },
        })
        .then((res) => {
            return res;
        });
}

export function groupDates(searchValue, filters) {
    let query = {
        ...buildQuery(searchValue, filters),
        size: 0,
        aggs: {
            resultado: {
                date_histogram: {
                    field: "informacion.fecha_sentencia",
                    calendar_interval: "month",
                    format: "MM-yyyy",
                    min_doc_count: 1,
                },
                aggs: {
                    activo: {
                        value_count: {
                            field: "id_relatoria.keyword",
                        },
                    },
                },
            },
        },
    };

    return axios.post(API_FILTERS, query).then((res) => {
        return res;
    });

}

export async function initSearch(text, filters, pageNumber = 1, sort) {
    //console.log(`Search page ${pageNumber}`);
    const results = await search(text, filters, pageNumber, sort).then(
        (res) => {
            return res;
        }
    );

    return results;
}

/**
 * Query para obtener los ids de una busqueda semántica
 * @param {string} text Texto a buscar
 * @param {*} filters
 * @param {*} pageNumber
 * @returns
 */
export async function getIdsBySemanticSearch(text, filters, pageNumber) {
    const textToSearch = text.replace(/['"]+/g, "");
    const body = { num_resultados: RESULTS_PER_PAGE, texto: textToSearch };

    try {
        const response = await fetch(API_SEARCH_SEMANTICA, {
            method: "POST",
            body: JSON.stringify(body),
            // mode: 'cors',
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "*",
                "Access-Control-Allow-Methods": "*",
            },
        });
        const { result } = await response.json();

        const results = result.map((resultItem) => resultItem[2]._id);

        return results;
    } catch (err) {
        console.error(err);
        return [];
    }
}

/**
 * Query para consultar una lista de ids en elastic search
 * @param {*} ids Array de ids a buscar
 * @returns
 */
export async function getResultsByIds(ids) {
    try {
        const response = await fetch(API_FILTERS, {
            method: "POST",
            body: JSON.stringify({
                query: {
                    bool: {
                        should: [
                            {
                                ids: {
                                    values: ids,
                                },
                            },
                        ],
                    },
                },
            }),
            headers: {
                "Content-Type": "application/json",
            },
        });

        const data = await response.json();

        return data;
    } catch (err) {
        console.error(err);
        return [];
    }
}
/**
 * Query para hacer búsquedas semánticas con texto y filtros
 *
 * @param {*} text
 * @param {*} semanticFilters
 * @param {*} pageNumber
 * @returns
 */
export async function semanticSearch(
    text,
    semanticFilters,
    generalFilters,
    pageNumber
) {
    const textToSearch = text.replace(/['"]+/g, "");

    // El endpoint cambia dependiendo de los filtros
    const searchEndpoint =
        Object.keys(semanticFilters).length === 0
            ? API_SEARCH_SEMANTICA // Si la busqueda no tiene filtros se utiliza el endpoint de busqueda semántica sencillo
            : API_SEARCH_SEMANTICA_SENTENCIA; // Si la busqueda tiene filtros se utiliza el endpoint de busqueda semántica con filtros

    try {
        const response = await fetch(searchEndpoint, {
            method: "POST",
            body: JSON.stringify({
                texto: textToSearch,
                ...semanticFilters,
                filter: generalFilters,
                size: RESULTS_PER_PAGE,
                from: (pageNumber - 1) * RESULTS_PER_PAGE,
            }),
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Headers": "*",
                "Access-Control-Allow-Methods": "*",
            },
        });
        const { result_elasticsearch } = await response.json();

        // Adaptación temporal para hacerla compatible con las vistas
        return { data: result_elasticsearch };
    } catch (err) {
        console.error(err);
        throw new Error("Empty result");
    }
}

export async function initSort(text, filters, pageNumber, sortType) {
    //console.log(`Sort page ${pageNumber}`);
    const results = await sort(text, filters, pageNumber, sortType).then(
        (res) => {
            return res;
        }
    );

    return results;
}

export async function searchDateGroups(text, filters) {
    const group = await groupDates(text, filters).then((res) => {
        return res;
    });
    return group;
}

export async function getCantidadBorradorByDefault() {
    // const cantidad = await axios
    //     .get(URL_VISOR)
    //     .then((res) => {
    //         return res.data.valor;
    //     })
    //     .catch((error) => {
    //         console.error("Error: ", error);
    //         return "1";
    //     });
    // return cantidad;
    return "1";
}

export function searchCitadoEn(query) {
    return fetch(CITADO_EN, {
        method: "POST",
        body: JSON.stringify(query),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            return data.results;
        })
        .catch((e) => {
            console.error(e);
        });
}

/**
 * Query para obtener el abstract de un archivo
 * @param {*} pathfile Path del archivo de transcripciones en S3
 * @param {*} keywords Palabras claves de búsqueda
 * @returns
 */
export async function getAbstract(pathfile, keywords) {
    if (!pathfile) return null;

    let keyFile = pathfile;
    keyFile = split(keyFile, ".");
    keyFile = keyFile[0] + ".txt";
    keyFile = split(keyFile, "/");
    keyFile = keyFile[keyFile.length - 1];

    const response = await fetch(API_ABSTRACT, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
            key: "Transcription/" + keyFile,
            bucket: "ssociedades-test-relatorias-transcription",
            keyWord: keywords,
        }),
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*", //CORS
        },
    });
    const abstract = await response.json();

    let summary = JSON.parse(abstract.summary);
    summary = summary.RESULTADO;

    return summary;
}

export async function getAbstractProblem(text, keywords) {
    const response = await fetch(API_ABSTRACT, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify({
            keyWord: keywords,
            texto: text,
        }),
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*", //CORS
        },
    });
    const abstract = await response.json();

    let summary = JSON.parse(abstract.summary);
    summary = summary.RESULTADO;

    return summary;
}

/**
 * Query múltiple para obtener todos los abstracts de un conjunto de hits
 * @param {*} hits
 * @param {*} keywords
 */
export const getAbstractsMap = async (hits, keywords) => {
    try {
        // Se extrae la información necesaria de cada abstract (y sólo de los resultados que tengan abstract)
        const hitsDocumentData = hits.reduce((allowedHits, hit) => {
            let additionalHits = [];

            if (hit?._source?.documento_principal?.ruta_s3) {
                return [
                    ...allowedHits,
                    {
                        id: hit._id,
                        documentPath: hit._source.documento_principal?.ruta_s3,
                    },
                ];
            }

            if (
                hit?._source?.informacion?.tipo_contenido ===
                "Temas y problemas"
            ) {
                additionalHits = [
                    ...hit._source.problemas_juridicos_temas.map(
                        (problem, index) => ({
                            id: hit._id + "_problem_" + index,
                            text: problem.posicion_doctrinal_actual,
                        })
                    ),
                ];
                return [...allowedHits, ...additionalHits];
            }

            return allowedHits;
        }, []);

        // Se consulta el resumen de cada uno
        const hitsSummaryData = await Promise.all(
            hitsDocumentData.map((hit) => {
                if (hit.documentPath) {
                    return getAbstract(hit.documentPath, keywords);
                } else {
                    return getAbstractProblem(hit.text, keywords);
                }
            })
        );

        // Se empieza a construir un mapa de abstracts con el id del hit como llave
        const abstracts = {};
        hitsDocumentData.forEach((hit, index) => {
            if (hitsSummaryData[index]) {
                // Actualmente solo se utiliza el primer resultado
                const [summary] = hitsSummaryData[index];

                abstracts[hit.id] = summary;
            }
        });

        return abstracts;
    } catch (error) {
        console.error("Error: ", error);
        return {};
    }
};

export async function sendLog(body) {
    const abstract = await fetch(LOG_BORRADOR, {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*", //CORS
        },
    })
        .then((res) => res.json())
        .then((response) => {})
        .catch((error) => console.error("Error:", error));

    return abstract;
}

export async function countByTipoContenido(body) {
    const count = await fetch(API_COUNT, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((res) => res.json())
        .then((response) => {
            return response;
        })
        .catch((error) => console.error("Error:", error));

    return count;
}

export const HIGHLIGHT_FIEDLS = [
    "analisis_estadistico.excepciones_esgrimidas_contra_la_demanda",
    "analisis_estadistico.excepciones_esgrimidas_reconvencion",
    "analisis_estadistico.expediente_tribunal",
    "analisis_estadistico.fecha_segunda_instancia",
    "analisis_estadistico.hechos_relevantes_contestacion_de_demanda",
    "analisis_estadistico.hechos_relevantes_demanda",
    "analisis_estadistico.intervencion_terceros",
    "analisis_estadistico.juramento_estimatorio",
    "analisis_estadistico.parte_resolutiva_primera_instancia",
    "analisis_estadistico.parte_resolutiva_segunda_instancia",
    "analisis_estadistico.pretensiones_esgrimidas_reconvencion",
    "analisis_estadistico.pretensiones_presentadas_en_la_demanda",
    "analisis_estadistico.sentido_del_fallo_primera_instancia",
    "analisis_estadistico.sentido_del_fallo_segunda_instancia",
    "analisis_juridico.aclaracion_o_adicion",
    "analisis_juridico.consideraciones_adicionales",
    "analisis_juridico.problemas_juridicos.problema",
    "analisis_juridico.problemas_juridicos.tesis",
    "analisis_juridico.rattio_decidendi",
    "analisis_juridico.segunda_instancia",
    "analisis_pautas_legales.preguntas_problemas_juridicos.preguntasProblema",
    "analisis_pautas_legales.preguntas_problemas_juridicos.respuestasFuentes",
    "analisis_pautas_legales.sintesis_segunda_instancia",
    "analisis_pautas_legales.pautas_legales",
    "analisis_pautas_legales.referencias_pautas_legales.referenciasAfines",
    "analisis_pautas_legales.referencias_pautas_legales.referenciasDiscordantes",
    "archivos.nombre",
    "archivos.ruta_s3",
    "borrador.keyword",
    "citas.fuente",
    "citas.fuente_reforma",
    "citas.hipervinculo",
    "descriptores.descriptor_principal",
    "descriptores.descriptores_secundarios",
    "documento_principal.contenido_archivo",
    "documento_principal.metadatos",
    "documento_principal.ruta_s3",
    "fuentes_juridicas.actions",
    "fuentes_juridicas.estado",
    "fuentes_juridicas.fuente",
    "fuentes_juridicas.fuente_reforma",
    "fuentes_juridicas.hipervinculo",
    "fuentes_juridicas.tipo",
    "id_relatoria.keyword",
    "informacion.ano_expediente",
    "informacion.consecutivo",
    "informacion.fecha_sentencia",
    "informacion.fecha_ultima_modificacion",
    "informacion.normatividad",
    "informacion.numero_proceso",
    "informacion.numero_radicado",
    "informacion.tema",
    "informacion.tramite",
    "metadatos.Antecedentes",
    "metadatos.Consideraciones",
    "metadatos.Costas",
    "metadatos.Hechos",
    "metadatos.Pretensiones",
    "metadatos.Resuelve",
    "partes.nombre",
    "partes.numero_doc",
    "partes.rol",
    "partes.tipo_doc",
    "problemas_juridicos_temas.posicion_doctrinal_actual",
    "problemas_juridicos_temas.posicion_doctrinal_contraria",
    "problemas_juridicos_temas.pregunta",
    "problemas_juridicos_temas.reiteracion_doctrina",
    "titulo.keyword",
];
